import React from 'react';

export const textToHtml=(text)=>{
    
    
    return <p dangerouslySetInnerHTML={{__html: text}} />
}